import { useMemo } from 'react';
import { FilterDocuments } from 'shared/constants';
import { useUser } from 'shared/hooks/use-user';

export const useInboxFilterDocument = () => {
  const user = useUser();
  const userFilters = user?.settings?.filters?.inbox;
  const defaultFilters = FilterDocuments.Inbox.defaultFilterDocument;

  return useMemo(
    () => ({
      ...defaultFilters,
      ...userFilters,
      filters: {
        ...defaultFilters.filters,
        ...userFilters?.filters,
      },
    }),
    [defaultFilters, userFilters],
  );
};
